/**
 * 2022-01-11
 * 其他（更多）产品的单元组件
 */

import Image from '@/components/UI/Image';
import EFArrowRightUp from '@/components/UI/svg/Icons/EFArrowRightUp';
import { isProductLinkInReadyStaticProductPage } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const defaultStyle = {
    wrapperWidth: '100%',
    wrapperHeight: 'auto',
    wrapperBackColor: '#f6f6f8',
    wrapperTextAlign: 'center',
    imgWidth: '350px',
    imgHeight: '320px',
    imgFill: 'contain',
    titleFontSize: '22px',
    titleColor: '#000000',
    titleLineHeight: '30px',
    titleHeight: 'auto',
    linkIsIcon: true,
    linkIconPosition: 'right',
    linkIconWidth: '20px',
    linkIconHeight: '21px',
    linkFontSize: '17px',
    linkColor: '#478fff', // rgb(71,143,255)
    linkIsUnderLine: false,
    linkLineHeight: '25px',
};

const defaultData = {
    imgUrl: '/img/delta11.png',
    titleText: 'EcoFlow DELTA Portable Power Station',
    linkText: 'Learn More',
    icon: <EFArrowRightUp />,
    linkUrl: '/',
};

/**
 * Style 样式参数
 * @param cssStyle: otherProductStyleType{
 *  wrapperWidth: 容器宽 string,
 *  wrapperHeight：容器高 string,
 *  wrapperBackColor：容器背景色 string,
 *  wrapperTextAlign: 容器内容文本对齐方式 string，
 *  imgWidth：图片宽 string,
 *  imgHeight: 图片高 string,
 *  imgFill：图片填充方式 string,
 *  titleFontSize: 标题文字大小 string，
 *  titleColor：标题文字颜色 string,
 *  titleLineHeight: 标题文字行高 string,
 *  titleHeight: 标题文字高 string,
 *  linkIsIcon： 链接是否带有icon图标 boolean,
 *  linkIconPosition: icon图标位置（左右）string,
 *  linkIconWidth: icon图标宽 string,
 *  linkIconHeight: icon图标高 string,
 *  linkFontSize: 链接文字大小 string,
 *  linkColor: 链接文字颜色 string,
 *  linkIsUnderLine: 链接是否有下划线 boolean,
 *  linkLineHeight: 链接文字行高 string
 * }
 */

/**
 * 数据参数
 * @param data :otherProductDataType{
 *  imgUrl: 图片路径 string,
 *  titleText: 标题文字 string,
 *  linkText: 链接文字 string,
 *  iconUrl: icon图标路径 string,
 *  linkUrl: 点击链接的跳转目标 string
 * }
 /**
  * 
  * @param deliveryTitleHeight 
  * function: 重新计算title文字行高度
  */
export default function OtherProductCell({ cssStyle, data, deliveryTitleHeight, resizeHeight, useDefaultTitle = true }: any) {
    const { Link, useRef, useEffect, useLang } = useGlobal();
    const styles = { ...defaultStyle, ...cssStyle };
    const dataObj = { ...defaultData, ...data };
    const titleHeightRef = useRef();
    const { t } = useLang('shared');

    useEffect(() => {
        deliveryTitleHeight(titleHeightRef?.current?.offsetHeight);
    }, [titleHeightRef?.current?.offsetHeight]);

    const gotoLink = (url: string) => {
        if (/^http/i.test(url) || isProductLinkInReadyStaticProductPage(url.substr(1))) {
            return { href: dataObj.linkUrl };
        }
        return {
            href: '/[...product]',
            as: `/${dataObj.linkUrl}`,
        };
    };

    return (
        <div
            className={`${css.otherProductCell} otherProductCell`}
            style={{
                width: styles.wrapperWidth,
                background: styles.wrapperBackColor,
                textAlign: styles.wrapperTextAlign,
            }}
        >
            <div className="img">
                <Image src={dataObj.imgUrl} layout="fill" className="containImgs" alt={dataObj.titleText}></Image>
            </div>
            <div className="box">
                <div className="titleBox">
                    <p
                        className="title font-family-bold"
                        ref={titleHeightRef}
                        style={{
                            color: styles.titleColor,
                            fontWeight: 500,
                            fontSize: styles.titleFontSize,
                            lineHeight: styles.titleLineHeight,
                            height: `${parseFloat(resizeHeight)}px `,
                        }}
                    >
                        {dataObj.titleText}
                    </p>
                </div>
                <Link
                    {...gotoLink(dataObj.linkUrl)}
                    ariaLabel={useDefaultTitle ? t('support.site_support_learn_more') : dataObj.linkText}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'select_product',
                        list_name: 'You might also like',
                        product_name: dataObj.titleText,
                        button_name: 'Learn more',
                    }}
                >
                    <div
                        className="des"
                        style={{
                            display: styles.linkIsIcon ? 'inline-block' : 'none',
                            color: styles.linkColor,
                            fontSize: styles.linkFontSize,
                            lineHeight: styles.linkLineHeight,
                            textDecoration: styles.linkIsUnderLine ? 'underline' : 'none',
                        }}
                    >
                        <span className="desText font-family-regular">{useDefaultTitle ? t('support.site_support_learn_more') : dataObj.linkText}</span>
                        <span className="icons">{dataObj.icon}</span>
                    </div>
                </Link>
            </div>
        </div>
    );
}
